import { useNavigate } from "react-router-dom";
import seriesStore from "../stores/seriesStore";
import statusStore from "../stores/statusStore";
import { filterByStatus } from "../utils/filterByStatus.js";

export default function MobileItems({selectedShow, setSelectedShow, selectedSeriesList, 
    setSelectedSeriesList, activeHeader, setActiveHeader}) {
    const navigate = useNavigate();

    const serStore = seriesStore();
    const staStore = statusStore();

    const { filteredSeries: startedSeries, filteredSeasons: startedSeasons } =
      filterByStatus(staStore.status, serStore.series, "Started");
    
    const { filteredSeries: toWatchSeries, filteredSeasons: toWatchSeasons } =
      filterByStatus(staStore.status, serStore.series, "To Watch");
  
    const { filteredSeries: comingSoonSeries, filteredSeasons: comingSoonSeasons } =
      filterByStatus(staStore.status, serStore.series, "Finished what's available");
  
    const { filteredSeries: stoppedSeries, filteredSeasons: stoppedSeasons } =
      filterByStatus(staStore.status, serStore.series, "Stopped");
  
    const { filteredSeries: finishedSeries, filteredSeasons: finishedSeasons } =
      filterByStatus(staStore.status, serStore.series, "Finished");

    return (
        <div className="popularItemsPage">

            {startedSeries?.length > 0 && (
            <div>
              <h3 className="popularItemsHeader">Started</h3>
              <div className="series-list">
                {startedSeries?.map((s) => {
                  return (
                  <div className="series-card" key={s._id}
                  onClick={() => {
                                navigate("/series", {  state: {
                                      selectedShow: s,
                                      selectedSeriesList: null,
                                      activeHeader: s._id
                                  } });
                            }}>
                      <img
                        src={s.poster}
                        alt={s.title}
                        className="series-image"
                      />
                  </div>
                  );
                })}
            </div>
          </div>
          )}

          {toWatchSeries?.length > 0 && (
          <div>
            <h3 className="popularItemsHeader">To Watch</h3>
              <div className="series-list">
                {toWatchSeries?.map((s) => {

                  return (
                  <div className="series-card" key={s._id}
                  onClick={() => {
                              navigate("/series", {  state: {
                                      selectedShow: s,
                                      selectedSeriesList: null,
                                      activeHeader: s._id
                                  } });
                            }}>
                      <img
                        src={s.poster}
                        alt={s.title}
                        className="series-image"
                      />
                  </div>
                  );
                })}
            </div>
          </div>
          )}

          {comingSoonSeries?.length > 0 && (
          <div>
            <h3 className="popularItemsHeader">Upcoming</h3>
            <div className="series-list">
              {comingSoonSeries?.map((s) => {

                return (
                <div className="series-card" key={s._id}
                onClick={() => {
                            navigate("/series", {  state: {
                                      selectedShow: s,
                                      selectedSeriesList: null,
                                      activeHeader: s._id
                                  } });
                          }}>
                    <img
                      src={s.poster}
                      alt={s.title}
                      className="series-image"
                    />
                </div>
                );
              })}
            </div>
          </div>
          )}

          {finishedSeries?.length > 0 && (
          <div>
            <h3 className="popularItemsHeader">Finished</h3>
            <div className="series-list">
              {finishedSeries?.map((s) => {

                return (
                <div className="series-card" key={s._id}
                onClick={() => {
                            navigate("/series", {  state: {
                                      selectedShow: s,
                                      selectedSeriesList: null,
                                      activeHeader: s._id
                                  } });
                          }}>
                    <img
                      src={s.poster}
                      alt={s.title}
                      className="series-image"
                    />
                </div>
                );
              })}
            </div>
          </div>
          )}
        
        {stoppedSeries?.length > 0 && (
        <div>
          <h3 className="popularItemsHeader">Stopped</h3>
          <div className="series-list">
            {stoppedSeries?.map((s) => {

              return (
              <div className="series-card" key={s._id}
              onClick={() => {
                          navigate("/series", {  state: {
                                      selectedShow: s,
                                      selectedSeriesList: null,
                                      activeHeader: s._id
                                  } });
                        }}>
                  <img
                    src={s.poster}
                    alt={s.title}
                    className="series-image"
                  />
              </div>
              );
            })}
          </div>
        </div>
        )}

      <div className="mobileItemsDivider">
        <hr></hr>
      </div>
      
      </div>
    )
}